<template>
  <div class="text-h5" style="margin-bottom: 44px;">
    Шаблоны документов
  </div>
  <div class="row">
    <div class="col-7 q-ma-lg">
      <q-btn label="Создать" icon="add" @click="$router.push({name: 'documents_template_create', params: {}})"/>
    </div>
    <div class="col-7 q-ma-lg">
      <q-table
        title=""
        :rows="documents_list"
        :columns="columns"
        row-key="name"
        @row-click="onRowClick"
      />
    </div>
  </div>
</template>

<script>
import {ref} from "vue";
import axios from "axios";
import {apiUrl} from "@/config";

const columns = [
  { name: 'id', label: '№ п/п', field: 'id', align: 'left' },
  { name: 'name', label: 'Название', field: 'name', align: 'left' }
];

export default {
  name: "templates_list",
  data() {
    this.emitter.on('onReceiveDocumentsList', (data) => {
      this.documents_list = data.items;
    })
    axios
        .post(apiUrl + '/admin/documents/list/', {}, {auth: this.$store.state.credentials})
        .then((response) => {
          this.emitter.emit('onReceiveDocumentsList', response.data);
        })
    return {
      documents_list: ref([]),
      columns: ref(columns),
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onRowClick(evt, row, index) {
      this.$router.push({name: 'documents_template_edit', params: {id: row.id}});
    }
  }
}


</script>

<style scoped>

</style>